import React from "react"

import styles from "./style.module.css"
import { Radio } from "antd"
import { twMerge } from "tailwind-merge"
import Tooltip from "components-old/Tooltip"
import { isAldeia } from "hooks/useAldeia"

interface IRadioboxProps {
  children: React.ReactNode
  icon?: React.ReactNode
  selected?: boolean
  value?: string
  tip?: string
  disabled?: boolean
  dashed?: boolean
  className?: string
}

function Radiobox(props: IRadioboxProps) {
  return (
    <Tooltip title={props.tip}>
      <label
        className={twMerge([
          "flex-center group relative h-[7rem] w-full cursor-pointer flex-col gap-2 rounded-lg text-sm text-center px-2",
          props.selected && !props.dashed && "outline-solid outline-2 outline outline-primary aldeia:outline-1",
          props.disabled && "opacity-50 pointer-events-none",
          !props.dashed && "bg-gray-100 hover:bg-gray-200 dark:bg-neutral-hover dark:hover:bg-neutral-focus",
          props.dashed &&
            "border-2 border-dashed aldeia:border-solid aldeia:dark:hover:bg-primary-lighter aldeia:border border-divider-100 kinbox:hover:border-divider-200 aldeia:light:hover:shadow-button-light transition-shadow duration-300",
          props.selected &&
            props.dashed &&
            "border-primary hover:border-primary bg-sky-50 aldeia:bg-primary-lighter aldeia:[&_i]:text-primary kinbox:dark:bg-base-200 ",
          props.className,
          isAldeia
            ? "fc animate-fade-up rounded-[16px] !animate-duration-200 [&_.ant-card-body]:flex [&_.ant-card-body]:gap-2 [&_.ant-card-body]:flex-col [&_.ant-card-body]:items-center [&_.ant-card-body]:justify-center !bg-base-100 dark:!bg-selected-lighter !border-solid !border !border-separator hover:!border-transparent hover:!shadow-lg transition-all duration-200 dark:duration-75  dark:hover:!bg-selected"
            : "",
          isAldeia && props.selected && "!shadow-lg",
        ])}
        // classList={{
        //     "bg-gray-200": checked(),
        //     "border border-primary": checked(),
        // }}
      >
        <i className="flex items-end text-xl kinbox:flex-1">{props.icon}</i>
        <Radio
          value={props.value}
          type="radio"
          className={twMerge([
            "radio radio-sm absolute top-1 right-1 checked:bg-primary kinbox:group-hover:visible",
            !props.selected ? "invisible" : "visible",
          ])}
          disabled={props.disabled}
          // classList={{
          //     invisible: !checked(),
          //     visible: checked(),
          // }}
          // {...inputProps}
          // checked={checked()}
        />
        <span className="kinbox:flex-1 aldeia:text-[16px]">{props.children}</span>
      </label>
    </Tooltip>
  )
}

export default Radiobox
